/* eslint-disable max-len */
import { ALLOWED_NOTIFICATION_TYPES, NOTIFICATION_TRADE_CONFIRMED, NOTIFICATION_TRADE_CONFIRMED_DELAY, NOTIFICATION_SHARES_TRADES } from '@/services/notifications/proxy';
import constants from '@/constants';

export function isOfferMatched(data) {
  return data.History !== null && data.History.length > 0 && data.Offer.RemainingQuantity === 0;
}

export default {
  namespaced: true,
  state: {
    notificationList: [],
    sideNotificationLevel: '',
    sideNotificationText: '',
    sideNotificationOnCloseCallback: null,
    lastConfirmedContractData: {},
    showNotificationsWidget: false,
  },
  mutations: {
    add(state, notification) {
      notification.index = (new Date()).getTime() + Math.floor(Math.random() * 10000);
      state.notificationList.push(notification);
    },
    remove(state, index) {
      const target = state.notificationList.find(i => i.index === index);
      const indexToSlice = state.notificationList.indexOf(target);
      if (indexToSlice === -1) return;
      const firstSlice = state.notificationList.slice(0, indexToSlice);
      const secondSlice = state.notificationList.slice(indexToSlice + 1);
      state.notificationList = [
        ...firstSlice,
        ...secondSlice,
      ];
    },
    clear(state) {
      state.notificationList = [];
    },
    setSideNotification(state, { text, level, onCloseCallback }) {
      state.sideNotificationLevel = level;
      state.sideNotificationText = text;
      state.sideNotificationOnCloseCallback = onCloseCallback;
    },
    clearSideNotification(state) {
      state.sideNotificationLevel = '';
      state.sideNotificationText = '';
      state.sideNotificationOnCloseCallback = null;
    },
    setLastConfirmedContractData(state, payload) {
      state.lastConfirmedContractData = payload;
    },
    toggleNotificationsWidget(state) {
      state.showNotificationsWidget = !state.showNotificationsWidget;
    },
    closeNotificationsWidget(state) {
      state.showNotificationsWidget = false;
    },
  },
  actions: {
    add({ commit, state }, notification) {
      if (notification.type === NOTIFICATION_TRADE_CONFIRMED) {
        setTimeout(() => {
          commit('add', notification);
          commit('setLastConfirmedContractData', {
            id: notification.data.ContractId,
            matched: isOfferMatched(notification.data),
          });
          if (notification.data && notification.data.Offer && notification.data.Offer.OfferId) {
            const associatedNotification = state.notificationList
              .filter(i => i.type === 'simple')
              .find(i => i.externalId === notification.data.Offer.OfferId);

            if (!associatedNotification) return;
            commit('remove', associatedNotification.index);
          }
        }, NOTIFICATION_TRADE_CONFIRMED_DELAY);
      } else if (notification.type === NOTIFICATION_SHARES_TRADES) {
        commit('setLastConfirmedContractData', {
          id: notification.data.contentJson.ContractId,
          matched: true,
        });
        commit('add', notification);
      } else if (ALLOWED_NOTIFICATION_TYPES.includes(notification.type)) {
        commit('add', notification);
      }
    },
    remove({ commit }, notificationIndex) {
      commit('remove', notificationIndex);
    },
    clear({ commit }) {
      commit('clear');
    },
    addSimple({ commit }, { icon, text, externalId = null, closeTimeout = constants.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT }) {
      const notification = {
        method: null,
        type: 'simple',
        externalId,
        data: {
          icon,
          text,
          closeTimeout,
        },
      };
      commit('add', notification);
    },
    setSideNotification({ commit }, { text, level }) {
      commit('setSideNotification', { text, level });
    },
    setSuccessSideNotification({ commit }, text) {
      commit('setSideNotification', { text, level: 'success' });
    },
    setSuccessSideNotificationWithTimeoutCallback({ commit }, { text, callback = () => {} }) {
      let callBackApplied = false;
      const timeout = setTimeout(
        () => {
          callBackApplied = true;
          callback.apply(this);
        },
        constants.DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT,
      );
      commit('setSideNotification', {
        text,
        level: 'success',
        onCloseCallback: () => {
          if (!callBackApplied) {
            clearTimeout(timeout);
            callback.apply(this);
          }
        },
      });
    },
    setErrorSideNotification({ commit }, text) {
      commit('setSideNotification', { text, level: 'danger' });
    },
    clearSideNotification({ commit }) {
      commit('clearSideNotification');
    },
    toggleNotificationsWidget({ commit }) {
      commit('toggleNotificationsWidget');
    },
    closeNotificationsWidget({ commit }) {
      commit('closeNotificationsWidget');
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js